
import { css } from 'lit';
export default css`
:host{
  display:block;
  position:relative;
  border-bottom-right-radius:2rem;
  transition:all 300ms;
  height:100%;
  --font-color:var(--primary-eggplant);
  --link-font-weight:var(--fw-normal);
}

:host([theme='dark']){
  background-color:var(--neutral-light);
}

:host([theme='light']){
  background-color:var(--primary-white);
  outline:solid 2px var(--purple-medium-neutral);
  outline-offset:-2px;
}

:host(:hover){
  background-color:var(--purple-indigo);
  outline-color:var(--purple-indigo);
}

:host([theme='dark']:hover){
  --font-color:var(--primary-white);
  color:var(--primary-white);
}

.news-card{
  display:flex;
  flex-direction:column;
  gap:var(--spacing-4);
  transition:all 300ms;
  padding:var(--spacing-6);
  color:var(--font-color);
  --link-font-weight:var(--fw-normal);
}
`;